const asafotufiamTNC = {
  header:
    "Asafotufiam TRIVIA (DIGITAL) TERMS AND CONDITIONS SUMMARY OF THE PROMOTION",
  body: [
    {
      title: "SUMMARY OF THE PROMOTION",
      details: `The Trivia is a Digital based activity for MTN Pulse.`,
    },
    {
      title: "ELIGIBILITY",
      details: `To be eligible to enter this Trivia and claim the Prize (a free voucher or Data), each Participant must be under the age 35 years.`,
    },
    {
      title: ``,
      details: `MTN Pulse subscribers who use Smartphones across Ghana are eligible to participate in this digital trivia.`,
    },
    {
      title: " ",
      details: `There will be no opt in by way of USSD channel to participate in the trivia.`,
    },
    {
      title: "",
      details: `Participants must have a valid Ghana card  for identification.`,
    },
    {
      title: ``,
      details: `TERMS`,
    },
    {
      title: ``,
      details: `The Trivia is valid from the 3rd of August to the 5th of August 2023.`,
    },
    {
      title: ``,
      details: `The first 5 participants to answer all questions correctly stand a chance for winning the prize (shopping voucher worth GHC 100 or Data equivalent)`,
    },
    {
      title: ``,
      details: `Eligible participants shall have three chances to answer the Trivia.`,
    },
    {
      title: ``,
      details: `The first 5 participants to answer all questions correctly stand a chance for winning the prize (shopping voucher worth GHC 100 or Data equivalent)

      `,
    },
    {
      title: ``,
      details: `Eligible participants will receive an In-App notification for qualifying for the voucher or Data.`,
    },
    {
      title: ``,
      details: `The audited selection process to determine the winners is final and no correspondence will be entered into in relation to this.  In the event of a dispute, MTN's decision is final and binding, and no further correspondence will be entertained.`,
    },
    {
      title: ``,
      details: `A shopping voucher or Data won is non-transferable non-refundable, cannot be exchanged for another item and cannot be redeemed for cash.`,
    },
    {
      title: ``,
      details: `SIMs dedicated solely for commercial transactions by Mobile Money Agents and merchants and the owners of the SIMS are ineligible for this Trivia.`,
    },
    {
      title: ``,
      details: `MTN Staff and their spouses as well as third party agents are barred from this Trivia.`,
    },
    {
      title: ``,
      details: `MTN reserves the right to disqualify a winner when it is proven that the winner used fraudulent means to participate in the Trivia. Such participants will be handed over to the police for prosecution.`,
    },
    {
      title: ``,
      details: `MTN reserves the right to alter the Terms and Conditions at any point in time during the duration of the Trivia, and the Terms and Conditions as amended will be posted on MTN's website.`,
    },
    {
      title: ``,
      details: `MTN shall not be liable where a force majeure/event beyond its control results in the annulment, shortening, extension or amendment of the Terms and Conditions of this Trivia. `,
    },
    {
      title: ``,
      details: `MTN shall not be liable to perform its obligations under this Trivia if the information provided by any winner is erroneous, incomplete or incorrect.`,
    },
    {
      title: ``,
      details: `A Participant hereby consents to MTN using and processing their personal information in accordance with the applicable data protection and privacy laws for processing of the Participant’s entry as stated in these Terms and Conditions, as well as for any marketing and promotions. The Participant may contact MTN in order to have their personal information verified, amended or removed from the MTN database.`,
    },
    {
      title: ``,
      details: `The personal data of the participants will be retained by MTN in accordance with the law and shall only be shared with the approved parties.`,
    },
    {
      title: ``,
      details: `Winners will be notified by MTN authorized personnel and via the number 0244 300 000 ONLY`,
    },
    {
      title: `GOVERNING LAW`,
      details: `This Trivia shall be governed by the laws of Ghana.`,
    },
  ],
};

export default asafotufiamTNC;
